import {useCallback} from 'react';
import AddForm from './components/add_form';

const CustomsDeclaration = ({setCodeVatInvalid, ...props}: CustomsDeclarationProps) => {
  const key = `${props.invoiceId}-${props.declaration.country_data.code}-${props.declaration.code}`;
  const setInvalid = useCallback((invalid: boolean) => setCodeVatInvalid({key, invalid}), [ key, setCodeVatInvalid ]);

  return <AddForm {...props} setIsConfirmButtonDisable={setInvalid} />;
};

export default CustomsDeclaration;
